

import type { Action } from '../model'
import type { Profile } from 'types'

import createReducer from '../createReducer'
import { ActionType, type RolesResponseData } from './types'





export interface AuthReducer {
  isAuthenticated: boolean
  profile: Profile | null
  roles: RolesResponseData | null
}

const defaultState: AuthReducer = {
  isAuthenticated: false,
  profile: null,
  roles: null,
}

export const authReducer = createReducer<AuthReducer>(defaultState, {
  [ActionType.SET_AUTH]: (state: AuthReducer, action: Action<AuthReducer['isAuthenticated']>) => ({
    ...state,
    isAuthenticated: action.payload,
  }),

  [ActionType.SET_PROFILE]: (state: AuthReducer, action: Action<AuthReducer['profile']>) => ({
    ...state,
    profile: action.payload,
  }),

  [ActionType.SET_ROLES]: (state: AuthReducer, action: Action<AuthReducer['roles']>) => ({
    ...state,
    roles: action.payload,
  }),
})
